import { ProductStatus } from '@models/product';
import { ProductModel } from '@models/product';
import { cdnImageUrl } from '@utils/image';
import React from 'react';
import { ReactComponent as BellICon } from '@assets/images/app/bell.svg';
import { ReactComponent as NaverPayIcon } from '@assets/images/app/icon-npay.svg';
import { useAuthStore } from '@stores/authStore';
import FavoriteButton from './FavoriteButton';

export const ProductDetailFooter: React.FC<{ data: ProductModel; onClick?: (e: any) => void }> = (props) => {
  const authStore = useAuthStore();
  const data = props.data;
  if (data.saleType === 'commerce' && (data?.status === ProductStatus.CLOSE || data.soldout)) {
    return (
      <div
        style={{
          width: '100%',
          position: 'absolute',
          bottom: 0,
          height: '72px',
          backgroundColor: 'white',
          alignItems: 'center',
          justifyContent: 'space-between',
          display: 'flex',
          flexDirection: 'row',
          padding: '16px',
          borderTop: '1px solid rgba(0,0,0, .04)',
        }}>
        <button
          className="link-button"
          style={{
            flexShrink: 0,
            justifySelf: 'flex-end',
            display: 'flex',
            height: '56px',
            borderRadius: '8px',
            background: 'var(--White-100, #D5D8DD)',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            fontWeight: 'bold',
            fontSize: '16px',
            color: '#FFFFFF',
            gap: '4px',
          }}>
          <div>{data?.closeText || '판매 종료'}</div>
        </button>
      </div>
    );
  }

  if (data?.status === ProductStatus.CLOSE || data?.soldout === true) {
    return (
      <div
        style={{
          width: '100%',
          position: 'absolute',
          bottom: 0,
          height: '72px',
          backgroundColor: 'white',
          alignItems: 'center',
          justifyContent: 'space-between',
          display: 'flex',
          flexDirection: 'row',
          padding: '16px',
          borderTop: '1px solid rgba(0,0,0, .04)',
        }}>
        <button
          className="link-button"
          style={{
            flexShrink: 0,
            justifySelf: 'flex-end',
            display: 'flex',
            height: '56px',
            borderRadius: '8px',
            border: '1px solid #FF509A',
            background: 'var(--White-100, #FFF)',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            fontWeight: 'bold',
            fontSize: '16px',
            color: '#FF3D8F',
            gap: '4px',
          }}
          onClick={props.onClick}>
          <BellICon />
          <div>오픈 알림 신청</div>
        </button>
      </div>
    );
  }

  if (data.saleType === 'commerce') {
    return (
      <div
        style={{
          display: 'flex',
          width: '100%',
          paddingLeft: '16px',
          paddingRight: '16px',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#ffffff',
          borderTop: '1px solid #f5f7fb',
          gap: '8px',
        }}>
        <FavoriteButton
          theme="white"
          style={{
            width: '56px',
            height: '56px',
            borderRadius: '8px',
            background: 'var(--Neutral-100, #242424)',
            boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 2px 10px 0px rgba(0, 0, 0, 0.08)',
            flexShirnk: 0,
          }}
          productId={data?._id}
          saleType={data?.saleType}
        />
        <button
          className="link-button"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '12px',
            marginBottom: '12px',
            height: '56px',
            backgroundColor: '#FF3D8F',
            borderRadius: '8px',
            paddingLeft: 0,
            paddingRight: 0,
            width: '100%',
            cursor: 'pointer',
            flex: 1,
          }}
          onClick={props.onClick}>
          <div
            style={{
              color: 'var(--White-100, #FFF)',
              textAlign: 'center',
              fontFamily: 'Pretendard',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '22px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
            }}>
            <div>바로 구매하기</div>
            {!authStore.user && <NaverPayIcon />}
          </div>
        </button>
      </div>
    );
  }

  return (
    <div>
      {data?.bottomTextBanner?.show && (
        <div
          style={{
            position: 'absolute',
            width: '100%',
            height: '40px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.9)',
            left: 0,
            right: 0,
            bottom: '72px',
            zIndex: 100,
          }}>
          {data?.bottomTextBanner?.icon && (
            <img
              style={{ width: '20px', height: '20px', marginRight: '4px', opacity: 1 }}
              src={cdnImageUrl(data?.bottomTextBanner?.icon)}
              alt=""
            />
          )}
          {data?.bottomTextBanner?.highlightText && (
            <div
              style={{
                color: '#ff676f',
                fontSize: '15px',
                lineHeight: '20px',
                fontWeight: 'bold',
                opacity: '1px',
                alignSelf: 'center',
                marginRight: '4px',
              }}>
              {data?.bottomTextBanner?.highlightText}
            </div>
          )}
          {data?.bottomTextBanner?.normalText && (
            <div
              style={{
                color: '#ffffff',
                fontSize: '15px',
                lineHeight: '20px',
                fontWeight: '500',
                opacity: '1px',
                alignSelf: 'center',
              }}>
              {data?.bottomTextBanner?.normalText}
            </div>
          )}
        </div>
      )}
      <div
        style={{
          width: '100%',
          position: 'absolute',
          bottom: 0,
          height: '72px',
          backgroundColor: 'white',
          alignItems: 'center',
          justifyContent: 'space-between',
          display: 'flex',
          flexDirection: 'row',
          padding: '16px',
          borderTop: '1px solid rgba(0,0,0, .04)',
          gap: '8px',
        }}>
        <FavoriteButton
          theme="white"
          style={{
            width: '56px',
            height: '56px',
            borderRadius: '8px',
            background: 'var(--Neutral-100, #242424)',
            boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 2px 10px 0px rgba(0, 0, 0, 0.08)',
            flexShirnk: 0,
          }}
          productId={data?._id}
          saleType={data?.saleType}
        />
        <button
          className="link-button"
          style={{
            color: '#FFFFFF',
            backgroundColor: '#FF3D8F',
            height: '56px',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '8px',
            textAlign: 'center',
            fontFamily: 'Pretendard',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '22px',
            flex: 1,
          }}
          onClick={props.onClick}>
          {'상담 후 구매하기'}
        </button>
      </div>
    </div>
  );
};
